import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  flex-grow: 1;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
`

export const CustomButton = styled(ButtonMui)`
  height: 2.5rem !important;
  margin: 0 !important;
`
